import React__default, { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { Box, Typography, Skeleton, Grid, TextField } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Format from '../../Format/index.js';
import KButton from '../../KButtons/index.js';
import StyledFormatsByType, { classes } from './index.styled.js';

var matchMeta = function (meta, search) {
    switch (meta.type) {
        case "extension":
            return meta.value.toLowerCase().search(search) !== -1;
        case "resolution":
            return meta.value.toString().search(search) !== -1;
        case "size":
            return (meta.value.height.toString().search(search) !== -1 ||
                meta.value.width.toString().search(search) !== -1);
        default:
            return false;
    }
};
var filteredFormats = function (formats, search) {
    var lowerCaseSearch = search.toLowerCase();
    if (lowerCaseSearch.length > 0) {
        var newFormats_1 = [];
        formats.forEach(function (format) {
            var matchTitle = format.title.toLowerCase().search(lowerCaseSearch) !== -1;
            var matchDescription = format.description.toLocaleLowerCase().search(lowerCaseSearch) !== -1;
            var matchMetas = function () { return format.metas.some(function (meta) { return matchMeta(meta, lowerCaseSearch); }); };
            if (matchTitle || matchDescription || matchMetas()) {
                newFormats_1.push(format);
            }
        });
        return newFormats_1;
    }
    return formats;
};
var handleOverflow = function (element) {
    if (element) {
        var clientWidth = element.clientWidth, scrollWidth = element.scrollWidth;
        return scrollWidth > clientWidth;
    }
    return false;
};
var FormatsByType = function (_a) {
    var _b = _a.formatsByType, formatsByType = _b === void 0 ? { type: "", formats: [], elements: [] } : _b, _c = _a.onSelectFormat, onSelectFormat = _c === void 0 ? function () { } : _c, _d = _a.onSelectFormatFavorite, onSelectFormatFavorite = _d === void 0 ? function () { } : _d, formatsActionsAvailable = _a.formatsActionsAvailable, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.single, single = _f === void 0 ? false : _f, sx = _a.sx, KIcon = _a.KIcon;
    var _g = useState(""), search = _g[0], setSearch = _g[1];
    var _h = useState(false), isOverflown = _h[0], setIsOverFlown = _h[1];
    var _j = useState(1), showBeforeOverflow = _j[0], setShowBeforeOverflow = _j[1];
    var _k = useState(false), open = _k[0], setOpen = _k[1];
    var t = useTranslation("refront-components").t;
    var formatsEl = useRef(null);
    var filteredFormatsRendered = filteredFormats(formatsByType.formats.slice(0, open ? formatsByType.formats.length : showBeforeOverflow), search);
    useLayoutEffect(function () {
        if (!loading && formatsByType.formats.length > 1) {
            var maxLength = formatsByType.formats.length;
            var maxReached = showBeforeOverflow === maxLength;
            if (!handleOverflow(formatsEl.current) && !maxReached && !isOverflown) {
                setShowBeforeOverflow(showBeforeOverflow + 1);
            }
            else if (handleOverflow(formatsEl.current)) {
                setShowBeforeOverflow(showBeforeOverflow - 1);
                setIsOverFlown(true);
            }
        }
    }, [formatsByType.formats.length, isOverflown, loading, showBeforeOverflow]);
    useEffect(function () {
        if (search.length > 0) {
            setOpen(true);
        }
    }, [search]);
    if (loading) {
        var random = Math.random() * Math.floor(3) + 1;
        var array = [];
        for (var i = 0; i < random; i += 1) {
            array.push(i);
        }
        return (React__default.createElement(StyledFormatsByType, { "data-testid": "FormatsByTypeLoading", className: clsx("FormatsByTypes"), sx: sx },
            React__default.createElement(Box, { className: classes.type },
                React__default.createElement(Typography, { variant: "h6", component: "div" },
                    React__default.createElement(Skeleton, { width: 200 }))),
            React__default.createElement(Box, { className: classes.details },
                React__default.createElement(Box, { className: classes.formats }, array.map(function (v) { return (React__default.createElement(Format, { key: v, loading: true })); })))));
    }
    return (React__default.createElement(StyledFormatsByType, { "data-testid": "FormatsByType", className: clsx("FormatsByTypes"), sx: sx },
        React__default.createElement(Box, { className: classes.type },
            React__default.createElement(Typography, { variant: "h6", component: "div" },
                single && "".concat(formatsByType.type),
                !single && "".concat(formatsByType.type, " (").concat(formatsByType.elements.length, ")"))),
        React__default.createElement(Box, { className: classes.details },
            isOverflown && (React__default.createElement(Grid, { container: true, className: classes.filters },
                React__default.createElement(Grid, { item: true, md: 4, sm: 8, xs: 12 },
                    React__default.createElement(TextField, { value: search, onChange: function (e) { return setSearch(e.target.value); }, fullWidth: true, label: t("components.downloadManager.typeLists.search.label"), placeholder: formatsByType.type, variant: "outlined", size: "small", type: "search", className: classes.searchContainer })))),
            formatsByType.formats.length === 0 && !loading && (React__default.createElement(Typography, { variant: "body2" }, t("components.downloadManager.typeLists.formats.no-rights.label", {
                count: formatsByType.elements.length
            }))),
            formatsByType.formats.length > 0 && (React__default.createElement("ul", { "aria-label": formatsByType.type, ref: formatsEl, className: clsx(classes.formats, open && classes.formatsOpen) },
                filteredFormatsRendered.map(function (format) { return (React__default.createElement(Box, { component: "li", key: format.id },
                    React__default.createElement(Format, { format: format, onClick: function () { return onSelectFormat(format.id); }, onClickFavorite: function () { return onSelectFormatFavorite(format.id); }, actionsAvailable: formatsActionsAvailable, KIcon: KIcon }))); }),
                isOverflown && !open && (React__default.createElement("li", { className: classes.addMoreContainer },
                    React__default.createElement(KButton, { color: "primary", variant: "outlined", className: classes.addMore, onClick: function () { return setOpen(true); } }, t("components.downloadManager.typeLists.addFormats", {
                        count: formatsByType.formats.length - showBeforeOverflow,
                        type: formatsByType.type
                    })))))))));
};

export { FormatsByType as default };
//# sourceMappingURL=index.js.map
